import { Box } from '@mui/material';
import type { WidaStudent } from '../Upload/widaHistory';
import { BelowExitPill, StatTile } from './components';
import {
  DOMAINS,
  DOMAIN_LABELS,
  belowExit,
  currentLevel,
  domainTrend,
  levelLabel,
  priorLevel,
  type PlanStudent,
} from './derive';
import { useReclassCriteria } from './reclassCriteriaContext';

function trendForTile(student: WidaStudent, key: 'listening' | 'speaking' | 'reading' | 'writing') {
  const t = domainTrend(student, key);
  return { category: t.category, label: t.label };
}

function caption(student: WidaStudent, key: 'listening' | 'speaking' | 'reading' | 'writing' | 'composite') {
  const prior = priorLevel(student, key);
  const current = currentLevel(student, key);
  if (prior == null || current == null) return 'First scored year on file';
  if (current > prior) return `Up from ${prior.toFixed(1)} last year`;
  if (current < prior) return `Down from ${prior.toFixed(1)} last year`;
  return `Unchanged from ${prior.toFixed(1)} last year`;
}

export function ProficiencySummaryTiles({
  student,
  year,
}: {
  student: PlanStudent;
  year: number | null;
}) {
  const criteria = useReclassCriteria();
  const composite = currentLevel(student, 'composite');
  const yearSuffix = year != null ? `'${String(year).slice(2)}` : '';

  return (
    <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
      <StatTile
        label={`ACCESS Composite ${yearSuffix}`}
        value={composite != null ? composite.toFixed(1) : '—'}
        valueSuffix={composite != null ? levelLabel(composite) : undefined}
        caption={caption(student, 'composite')}
        flag={belowExit(student, criteria, 'composite') ? <BelowExitPill /> : undefined}
        emphasize
      />
      {DOMAINS.map((d) => {
        const level = currentLevel(student, d);
        return (
          <StatTile
            key={d}
            label={DOMAIN_LABELS[d]}
            value={level != null ? level.toFixed(1) : '—'}
            trend={trendForTile(student, d)}
            flag={belowExit(student, criteria, d) ? <BelowExitPill /> : undefined}
            caption={caption(student, d)}
          />
        );
      })}
    </Box>
  );
}
